import TableActionMenu from "../../../../../components/table-action-menu/table-action-menu";
import { Link } from "react-router-dom";

export const tableMenuOptions = (handleDeleteLink, rowData) => {
  const options = [
    {
      title: "Delete Link",
      value: "delete",
      onClick: () => handleDeleteLink(rowData),
    },
  ];
  return options;
};

export const linkedAssetsColumns = (handleDeleteLink) => {
  return [
    {
      name: "Name",
      dataKey: "linkedAsset",
      width: "45%",
      align: "left",
      sortable: true,
      render: (cellData, rowData) => {
        const link = rowData.linkedAsset.startsWith("http://") || rowData.linkedAsset.startsWith("https://")
          ? rowData.linkedAsset
          : `https://${rowData.linkedAsset}`; // Prepend `https://` if missing
  
        return (
          <a
            href={link} // Use the validated external link
            target="_blank" // Open the link in a new tab
            rel="noopener noreferrer" // Prevent security vulnerabilities
            style={{ color: "#080425", textDecoration: "underline" }}
          >
            {rowData.linkedAsset}
          </a>
        );
      },
    },
    {
      name: "Date Added",
      dataKey: "dateAdded",
      width: "10%",
      align: "left",
      sortable: true,
    },

    {
      name: "Provided By",
      dataKey: "providedBy",
      width: "15%",
      align: "left",
      sortable: true,
    },
    {
        name: "",
        dataKey: "",
        width: "3%",
        align: "left",
  
        render: (cellData, rowData) => {
          return (
            <div style={{ marginRight: "15px" }}>
              <TableActionMenu options={tableMenuOptions(handleDeleteLink, rowData)} />
            </div>
          );
        },
      },
  ];
};
